export const apiPayment = {
  getHistoryPayment: '/payment-service/api/payment/app-balanceHistory',
  checkReqPayment: '/payment-service/api/payment/checkReq',
  createPayment: '/payment-service/api/payment/createReq',
  getInfoPayment: '/payment-service/api/payment/detailHistory',
};
